var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTripManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.893,
    height: 25.615,
    viewBox: "0 0 31.893 25.615",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Trip_Management",
    "data-name": "Trip Management",
    transform: "translate(1808.792 -4697.192)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-route",
    "data-name": "Icon awesome-route",
    d: "M20.813,16.01h-4.8a1.6,1.6,0,1,1,0-3.2h4.8s4.8-5.353,4.8-8a4.8,4.8,0,0,0-9.606,0c0,1.276,1.111,3.172,2.266,4.8H16.01a4.8,4.8,0,1,0,0,9.606h4.8a1.6,1.6,0,0,1,0,3.2H9.281a34.541,34.541,0,0,1-2.366,3.2h13.9a4.8,4.8,0,1,0,0-9.606Zm0-12.808a1.6,1.6,0,1,1-1.6,1.6A1.6,1.6,0,0,1,20.813,3.2Z",
    transform: "translate(-1802.515 4697.192)",
    fill: "#4bb2d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-truck",
    "data-name": "Icon awesome-truck",
    d: "M12.862,7.255h-.33V5.027a.989.989,0,0,0-.291-.7L10.182,2.269a.989.989,0,0,0-.7-.291H8.575V.989A.99.99,0,0,0,7.585,0H.989A.99.99,0,0,0,0,.989v6.6a.99.99,0,0,0,.989.989h.33a1.979,1.979,0,0,0,3.957,0H7.915a1.979,1.979,0,1,0,3.957,0h.989a.331.331,0,0,0,.33-.33v-.66A.331.331,0,0,0,12.862,7.255ZM3.3,9.564a.989.989,0,1,1,.989-.989A.99.99,0,0,1,3.3,9.564Zm6.6,0a.989.989,0,1,1,.989-.989A.99.99,0,0,1,9.894,9.564Zm1.649-4.287H8.575V2.968h.909l2.059,2.059Z",
    transform: "translate(-1808.792 4712.254)",
    fill: "#4bb2d8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTripManagement);
export default __webpack_public_path__ + "static/media/Trip Management.596737d234ef9d85b5e086e5ce37be3e.svg";
export { ForwardRef as ReactComponent };